import { journeyAction, } from './base';

import { JourneyActionVoiceVoicemail as JourneyActionVoiceVoicemailBase, } from 'atlas-shared';

export const JourneyActionVoiceVoicemail = journeyAction({
  ...JourneyActionVoiceVoicemailBase,
  icon: 'Voicemail',
});
